import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ArrowRight, Wheat, Calendar } from 'lucide-react';
import { blogs } from '../data/mock';

const BlogsPage = () => {
  return (
    <div className="pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#FAFFEE] to-[#EDEDFE] relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#D3FF62]/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 -left-40 w-96 h-96 bg-[#CACAFC]/30 rounded-full blur-3xl" />
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-[#0C6951] font-semibold uppercase tracking-wider">
              <Link to="/" className="hover:text-[#004534]">Home</Link>
              <ChevronRight className="w-4 h-4" />
              Blogs
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mt-4 mb-6 leading-tight">
              Knowledge Center
            </h1>
            <p className="text-xl text-[#0C6951] leading-relaxed">
              Insights, tips, and market analysis to help farmers and businesses make informed decisions.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog) => (
              <article
                key={blog.id}
                className="bg-[#FAFAFF] rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="h-48 bg-gradient-to-br from-[#CACAFC] to-[#EDEDFE] flex items-center justify-center relative overflow-hidden">
                  {blog.image ? (
                    <img 
                      src={blog.image} 
                      alt={blog.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  ) : (
                    <Wheat className="w-20 h-20 text-[#004534]/20 group-hover:scale-110 transition-transform duration-300" />
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-[#807979] mb-3">
                    <Calendar className="w-4 h-4" />
                    {blog.date}
                  </div>
                  <h3 className="text-lg font-semibold text-[#004534] mb-3 line-clamp-2 group-hover:text-[#0C6951] transition-colors">
                    {blog.title}
                  </h3>
                  <p className="text-[#807979] text-sm line-clamp-3 mb-4">{blog.excerpt}</p>
                  <Link
                    to={`/blogs/${blog.slug}`}
                    className="inline-flex items-center gap-2 text-[#004534] font-medium text-sm hover:gap-3 transition-all duration-200"
                  >
                    Read Article <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-[#FAFFEE]">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-[#004534] mb-4">Stay Updated</h2>
            <p className="text-[#807979] mb-8">
              Subscribe to our newsletter for the latest insights on agricultural markets and farming practices.
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-4 rounded-full border border-[#DDDDDD] focus:outline-none focus:border-[#004534] transition-colors"
              />
              <button
                type="submit"
                className="bg-[#004534] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#0C6951] transition-all duration-200"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogsPage;
